import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { RolesResourceEnum } from '../models/roles.resource';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { FALSE } from '../utils/config/const';

@Injectable({
    providedIn: 'root'
})
export class RoleGuard implements CanActivate {
    private roles = RolesResourceEnum;
    constructor(
        public auth: AuthenticationService,
        public router: Router) { }
    canActivate(route: ActivatedRouteSnapshot): boolean {
        //Controllo che ruolo si aspetta
        let expectedRole = this.getExpectedRole(route);

        //Controllo dati utente
        const currentUser = this.auth.currentUserValue;
        let userRole = "";
        if (currentUser && currentUser.userGoogle && currentUser.userBackend) {
            userRole = this.getUserRole(currentUser);
        }

        if (userRole != this.roles.ROLE_ADMIN && userRole != this.roles.ROLE_NOOVLE) {
            return this.checkRolePage(expectedRole,userRole);
        }

        return true;
    }

    checkRolePage(expectedRole,userRole){
        let userRoleItsOk = false;
        if (expectedRole != null) {
            if (expectedRole.length > 0) {
                //Controllo se il ruolo va bene per quelli elencati
                for (let role of expectedRole) {
                    if (role.toLowerCase() === userRole.toLowerCase()) {
                        userRoleItsOk = true;
                    }
                }
            }
        }
        if(userRoleItsOk == FALSE){
            this.router.navigate(['home']);
        }
        return userRoleItsOk;
    }


    getExpectedRole(route){
        let expectedRole = null;
        if (typeof route.data != typeof undefined) {
            if (typeof route.data.expectedRole != typeof undefined) {
                expectedRole = route.data.expectedRole;
            }
        }
        return expectedRole;
    }

    getUserRole(currentUserObj) {
        let res = "";
        if (typeof currentUserObj != typeof undefined) {
            for (let i = 0; i < currentUserObj.userBackend.authorities.length && res == ""; i++) {
                if (currentUserObj.userBackend.authorities[i].authority.startsWith("ROLE_")) {
                    res = currentUserObj.userBackend.authorities[i].authority;
                }
            }
        }
        return res;
    }
}